'use strict';

export default class Whatsapp {
  constructor() {
    this.name = 'whatsapp';
    var element = document.getElementById('whatsapp-link');

    var tels = ['5491157085666', '5491125017199'];
    //var tel = tels[Math.floor(Math.random() * 2)];
    var tel = '5491157085666';

    element.href = `https://wa.me/${tel}?text=Hola%2C%20me%20estoy%20comunicando%20del%20sitio%20web%20de%20hoggax%20para%20hacer%20una%20consulta`;
    
  }
}
